import React, { useState, useEffect } from 'react';
import { 
  Modal, 
  Box, 
  TextField, 
  Button, 
  Typography, 
  IconButton,
  Paper,
  Grid,
  Divider
} from '@mui/material';
import { ModalBox } from '../../../styles/ModalStyles';
import CloseIcon from '@mui/icons-material/Close';
import CheckboxGroup from '../../data/CheckBox';
import { getTipoDocumentoHabilitado } from '../../http/actions/TipoDocumentoAction';

const NuevoOrganismoEmisorModal = ({ open, onClose, onSubmit }) => {
  const [nombre, setNombre] = useState('');
  const [sigla, setSigla] = useState('');
  const [nombreAbreviado, setNombreAbreviado] = useState('');
  const [tiposDocumento, setTiposDocumento] = useState([]);
  const [selectedTipos, setSelectedTipos] = useState([]);
  const [isLoadingTipos, setIsLoadingTipos] = useState(false);

  // Cargar tipos de documento cuando se abre el modal
  useEffect(() => {
    if (open) {
      fetchTiposDocumento();
    }
  }, [open]);

  const fetchTiposDocumento = async () => {
    try {
      setIsLoadingTipos(true);
      const response = await getTipoDocumentoHabilitado(localStorage.getItem("token"));
      setTiposDocumento(Array.isArray(response) ? response : []);
    } catch (error) {
      console.error("Error al cargar tipos de documento:", error);
      setTiposDocumento([]);
    } finally {
      setIsLoadingTipos(false);
    }
  };

  const handleCheckboxChange = (event, id) => {
    const { checked } = event.target;
    setSelectedTipos(prev => 
      checked 
        ? [...prev, id]
        : prev.filter(item => item !== id)
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Preparar datos para enviar
    const organismoData = {
      nombre,
      sigla,
      nombreAbreviado,
      idTipoDocumento: selectedTipos
    };
    
    onSubmit(organismoData);
    
    // Limpiar formulario
    setNombre('');
    setSigla('');
    setNombreAbreviado('');
    setSelectedTipos([]);
    onClose();
  };

  const handleClose = () => {
    // Limpiar formulario al cerrar
    setNombre('');
    setSigla('');
    setNombreAbreviado('');
    setSelectedTipos([]);
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <ModalBox sx={{ width: '80%', maxWidth: '800px', maxHeight: '90vh', overflow: 'auto' }}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        
        <Typography variant='h6' gutterBottom>
          Nuevo organismo emisor
        </Typography>
        
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {/* Datos básicos del organismo */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Sigla"
                value={sigla}
                onChange={(e) => setSigla(e.target.value)}
                margin="normal"
                required
              />
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Nombre"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                margin="normal"
                required
              />
            </Grid>
            
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Nombre Abreviado"
                placeholder="Opcional"
                value={nombreAbreviado}
                onChange={(e) => setNombreAbreviado(e.target.value)}
                margin="normal"
              />
            </Grid>
            
            {/* Sección de tipos de documento */}
            <Grid item xs={12}>
              <Divider sx={{ my: 2 }} />
              <Typography variant="h6" gutterBottom>
                Tipos de Documento Asociados
              </Typography>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Selecciona los tipos de documento que puede emitir este organismo (opcional)
              </Typography>
              
              <Paper 
                elevation={1} 
                sx={{ 
                  p: 2, 
                  mt: 2,
                  bgcolor: 'background.default',
                  borderRadius: 2,
                  minHeight: 200
                }}
              >
                {isLoadingTipos ? (
                  <Typography>Cargando tipos de documento...</Typography>
                ) : (
                  <CheckboxGroup
                    title=""
                    items={tiposDocumento}
                    selectedItems={selectedTipos}
                    onChange={handleCheckboxChange}
                    name="tiposDocumento"
                    showSelectAll={true}
                  />
                )}
              </Paper>
            </Grid>
          </Grid>
          
          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
            <Button type="submit" variant="contained" color="primary">
              Guardar
            </Button>
            <Button onClick={handleClose} variant="contained" color="error">
              Cancelar
            </Button>
            
          </Box>
        </form>
      </ModalBox>
    </Modal>
  );
};

export default NuevoOrganismoEmisorModal;